/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Results_With_ListeningInputs */

const en_onboarding_results_with_listening = /** @type {(inputs: Onboarding_Results_With_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With listening`)
};

const es_onboarding_results_with_listening = /** @type {(inputs: Onboarding_Results_With_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con Listening`)
};

/**
* | output |
* | --- |
* | "With listening" |
*
* @param {Onboarding_Results_With_ListeningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_results_with_listening = /** @type {((inputs?: Onboarding_Results_With_ListeningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Results_With_ListeningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_results_with_listening(inputs)
	return en_onboarding_results_with_listening(inputs)
});